import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../components/App.css";
import axios from "axios";
import { API_BASE_URL } from "../config/config";
import { Container } from "@mui/material";
import { Modal, Button } from "react-bootstrap";

const Support = () => {
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [type, setType] = useState("");
  const [description, setDescription] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("care_token");
      if (!token) {
        navigate("/login");
        return;
      }

      const response = await axios.post(
        `${API_BASE_URL}/sendmail`,
        {
          userMail: email,
          subject,
          type,
          description,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log(response.data.message);

      setShowSuccessModal(true);
    } catch (error) {
      console.error("Error sending email:", error);
      setErrorMessage("Failed to send email. Please try again.");
      setShowErrorModal(true);
    }
  };

  return (
    <>
      <Container>
        <div className="raise-ticket-container">
          <div>
            <h3>Raise a Ticket</h3>
            <p>
              If you have any questions related to your subscription and account
              raise ticket.
            </p>
            <p>
              Email us at:{" "}
              <a href="mailto:partner@gadcare.com">partner@gadcare.com</a>
            </p>
            <p>
              Customer Helpline: <a href="tel:xxxxxxxxxx">xxxxxxxxxx</a>
            </p>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="email">Email*</label>
                <input
                  type="email"
                  id="email"
                  className="input-field"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="subject">Subject*</label>
                <input
                  type="text"
                  id="subject"
                  className="input-field"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="type">Type*</label>
                <select
                  id="type"
                  className="select-field"
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                  required
                >
                  <option value="">Select Type</option>
                  <option value="Product Care">Product Care</option>
                  <option value="Account">Account</option>
                  <option value="Claim">Claim</option>
                  <option value="Other">Other</option>
                  <option value="Bulk Sales">Bulk Sales</option>
                  <option value="Complaint">Complaint</option>
                  <option value="Question">Question</option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="description">Description*</label>
                <textarea
                  id="description"
                  className="textarea-field"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  required
                ></textarea>
              </div>
              <div className="raise-ticket-buttons">
                <button type="submit" className="submit-btn">
                  Submit
                </button>
                <button
                  type="button"
                  className="cancel-btn"
                  onClick={() => console.log("Cancelled")}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </Container>
      <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Your support request has been successfully sent.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setShowSuccessModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showErrorModal} onHide={() => setShowErrorModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>{errorMessage}</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setShowErrorModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Support;
